<template>
  <div class="footer-root">
    <ul :style="titleStyle" :class="pageClass" class="title">
      <li class="company">
        <dl>
          <dt>会社情報</dt>
          <dd></dd>
        </dl>
      </li>
      <li class="contact">
        <dl>
          <dt>コンタクト</dt>
          <dd></dd>
        </dl>
      </li>
      <li class="concept">
        <dl>
          <dt>コンセプト</dt>
          <dd></dd>
        </dl>
      </li>
      <li class="business">
        <dl>
          <dt>事業案内</dt>
          <dd></dd>
        </dl>
      </li>
      <li class="company">
        <dl>
          <dt>会社情報</dt>
          <dd></dd>
        </dl>
      </li>
      <li class="contact">
        <dl>
          <dt>コンタクト</dt>
          <dd></dd>
        </dl>
      </li>
      <li class="concept">
        <dl>
          <dt>コンセプト</dt>
          <dd></dd>
        </dl>
      </li>
      <li class="business">
        <dl>
          <dt>事業案内</dt>
          <dd></dd>
        </dl>
      </li>
    </ul>
    <div class="copyright"></div>
    <div v-show="showScroll" class="scroll"></div>
  </div>
</template>

<script>
export default {
  props: {
    page: {
      default: 'concept',
      type: String
    },
    device: {
      default: 'pc',
      type: String
    }
  },

  computed: {
    showScroll() {
      return this.$store.getters.currentPage !== 'contact'
    },

    pageClass() {
      return this.rate === 1 ? this.$store.getters.currentPage : ''
    },

    rate() {
      const currentPage = this.$store.getters.currentPage
      let rate

      if (currentPage == 'concept') {
        rate = this.$store.getters.conceptPageRate
      } else if (currentPage == 'business') {
        rate = this.$store.getters.businessPageRate
      } else if (currentPage == 'company') {
        rate = this.$store.getters.companyPageRate
      } else if (currentPage == 'contact') {
        rate = this.$store.getters.contactPageRate
      }

      return rate
    },

    titleStyle() {
      const titleWidth = (this.device === 'pc' ? 320 : 200) + 20 * 2
      const currentPageIndex = this.$store.getters.currentPageIndex

      const x = (currentPageIndex + this.rate) * titleWidth

      return {
        transition: 'transform 1s',
        transform: `translateX(${-x}px)`
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.footer-root
  position: fixed
  width: 1280px
  bottom: 0
  left: 50%
  margin-left: -640px

.input
  .footer-root
    .title
      opacity: 0

.sp
  .title
    bottom: 28px
    left: -240px
    height: auto
    transition: opacity .3s
    li
      dd
        height: 30px
        width: 200px

  .scroll
    width: 25px
    height: 120px
    position: fixed
    right: 60px
    bottom: 20px
    background-image: url('/images/sp/scroll.svg')
    background-repeat: no-repeat
    background-position: right bottom

  .copyright
    width: 15px
    height: 200px
    position: fixed
    right: 20px
    bottom: 20px
    background-image: url('/images/sp/footer.svg')
    background-repeat: no-repeat
    background-position: right bottom


.title
  width: 1700px
  height: 78px
  position: fixed
  bottom: 60px
  left: -230px
  display: flex
  margin: 0
  padding: 0

  @each $title in concept, business, company, contact
    &.#{$title}
      li.#{$title}
        dt
          opacity: 1
        dd
          filter: blur(0)
          opacity: 1

  li
    list-style: none
    margin: 0 20px
    dl
      margin: 0
    dt
      font-size: 15px
      margin-bottom: 18px
      transition: opacity .5s
      opacity: 0
    dd
      transition: opacity .5s, filter .5s
      margin-left: 0
      font-size: 40px
      font-weight: bold
      background-repeat: no-repeat
      background-size: contain
      background-position: left
      height: 42px
      width: 320px
      filter: blur(2px)
      opacity: 0.3

    @each $title in concept, business, company, contact
      &.#{$title}
        dd
          background-image: url('/images/title/title-#{$title}.svg')

.copyright
  width: 300px
  height: 15px
  position: fixed
  right: 28px
  bottom: 28px
  background-image: url('/images/footer.svg')
  background-repeat: no-repeat
  background-position: right center

.scroll
  width: 50px
  height: 98px
  margin: 0 auto
  margin-bottom: 28px
  background-image: url('/images/scroll.svg')
  background-repeat: no-repeat
  background-position: right center
</style>
